import { AppModel } from "../types/AppModel";

export const Games: AppModel[] = [{
  name: "Ascension: Tower Climb",
  image: process.env.PUBLIC_URL + 'Assets/Ascension.png',
  description: "Welcome to Ascension, The goal is simple, don't let the falling blocks get your goat! The game features Billy, a spunky little goat that may be the most adorable thing that you’ve ever seen, but he’s not kidding around, he’s got some pretty lofty goals, and you are in charge of helping him achieve them. Blocks will continouosly fall from the sky, and you need to use them to climb as high as you can! Don’t get squished by the the blocks as they fall, and don’t fall off your tower, because if you do, you’ll have to start over.",
  upVotes: 0,
  downVotes: 0,
  docsLink: ""
}]